import { fmt } from "@/lib/api";

export default function StatTiles({ usage }) {
  const tiles = [
    ["Avg daily", `${fmt.num(usage.avg_daily_kwh, 2)}`, "kWh / day", "avg-daily"],
    ["Peak demand", `${fmt.num(usage.peak_kw, 2)}`, `kW · ${fmt.time(usage.peak_ts)}`, "peak"],
    ["Night load", `${fmt.num(usage.night_kwh, 2)}`, `kWh · ${usage.night_share}% after dusk`, "night"],
    ["Monitoring", `${usage.days}`, `days · ${usage.readings_count.toLocaleString()} samples`, "days"],
    ["Live now", usage.live ? `${fmt.num(usage.live.power_w, 0)}` : "—", usage.live ? `W · ${usage.live.voltage} V · ${usage.live.current} A` : "no signal", "live"],
    ["Total", `${fmt.num(usage.total_kwh, 1)}`, "kWh recorded", "total"],
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-px bg-kl-lineLight border border-kl-lineLight" data-testid="stat-tiles">
      {tiles.map(([l, v, s, id], i) => (
        <div key={l} className={`p-5 animate-rise ${id === "live" ? "bg-kl-black text-white" : "bg-white"}`} style={{ animationDelay: `${i * 40}ms` }} data-testid={`stat-${id}`}>
          <div className={id === "live" ? "kl-label-dark" : "kl-label"}>{l}</div>
          <div className={`font-mono text-3xl mt-2 tracking-tight ${id === "live" ? "text-kl-green" : ""}`}>{v}</div>
          <div className={`text-[11px] mt-1 ${id === "live" ? "text-kl-muted" : "text-kl-mutedLight"}`}>{s}</div>
        </div>
      ))}
    </div>
  );
}
